// Static mock content for the www dashboard mockup -- every page under /app/* that isn't
// Proposals (the one real, backend-connected module today) reads from here. Nothing here calls
// an API; this is deliberately hand-authored content standing in for what will eventually be
// separate federated remotes (home-inventory, services, calendar, recipes), per direct
// instruction: "just use random names but link the panels in logic like the example" -- a single
// household's data, cross-referenced across pages the way two different signed-in people would
// eventually see two different halves of it.
export const INVENTORY_ITEMS = [
    {
        id: "car",
        name: "2019 Honda CR-V",
        meta: "Vehicle · 34,200 miles",
        icon: "car",
        tasks: [
            { id: "oil", title: "Oil change", detail: "every 5,000 mi", tone: "due", due: "due in 12 days" },
            { id: "tires", title: "Tire rotation", detail: "every 6 months", tone: "track", due: "on track · Dec 1" },
        ],
    },
    {
        id: "hvac",
        name: "HVAC system",
        meta: "Installed 2018 · Carrier",
        icon: "flame",
        tasks: [
            { id: "filter", title: "Furnace filter", detail: "every 3 months", tone: "overdue", due: "8 days overdue" },
            { id: "tuneup", title: "Annual tune-up", detail: "before winter", tone: "track", due: "on track · Oct 28" },
        ],
    },
    {
        id: "water-heater",
        name: "Water heater",
        meta: "40-gal tank · installed 2020",
        icon: "droplet",
        tasks: [{ id: "flush", title: "Flush tank", detail: "annual", tone: "due", due: "due in 19 days" }],
    },
    {
        id: "yard",
        name: "Yard & exterior",
        meta: "0.3 acre lot",
        icon: "leaf",
        tasks: [
            { id: "gutters", title: "Gutter cleaning", detail: "spring & fall", tone: "track", due: "on track · Nov 2" },
            { id: "lights", title: "Christmas lights install", detail: "seasonal, before first freeze", tone: "due", due: "plan by Nov 1" },
        ],
    },
];
export const ALL_INVENTORY_TASKS = INVENTORY_ITEMS.flatMap((item) => item.tasks.map((t) => ({ ...t, itemName: item.name, itemId: item.id })));
export const ACTIVE_SERVICES = [
    { id: "lawn", title: "Lawn mowing · biweekly plan", provider: "GreenLine Lawn Co.", status: "confirmed · next Fri", tone: "track" },
    { id: "haircuts", title: "Haircut package · 5-pack", provider: "The Fifth Chair", status: "3 of 5 remaining", tone: "neutral" },
];
export const SERVICE_CATALOG = [
    {
        id: "oil-change",
        title: "Oil change",
        icon: "car",
        providers: [
            { id: "quicklube", title: "QuickLube on 5th", provider: "40 min · no appointment needed", price: "$54" },
            { id: "honda-dealer", title: "Honda of Maple St. (dealer)", provider: "Book online · uses your VIN on file", price: "$89" },
        ],
    },
    {
        id: "snow-removal",
        title: "Snow removal",
        icon: "snow",
        providers: [
            { id: "northside", title: "Northside Snow Co.", provider: "Per-storm, driveway + walkway", price: "$45/visit" },
            { id: "ridge", title: "Ridge Property Services", provider: "Flat seasonal contract", price: "$320/season" },
        ],
    },
    {
        id: "cleaning",
        title: "House cleaning",
        icon: "clean",
        providers: [{ id: "sparkle", title: "Sparkle Home Services", provider: "Biweekly, 2 br / 2 ba", price: "$120/visit" }],
    },
];
export const UPCOMING_APPOINTMENTS = [
    { id: "haircut", title: "Haircut · Fade & line-up", provider: "The Fifth Chair · with Marcus", when: "Sat, 10:30a", tone: "neutral" },
    { id: "lawn-visit", title: "Lawn mowing", provider: "GreenLine Lawn Co.", when: "Fri", tone: "track" },
    { id: "oil-unbooked", title: "Oil change", provider: "from Home Inventory · not yet booked", when: "due in 12 days", tone: "due", linkToServices: true },
];
// Cross-person household scenario. Names are placeholders, not the real account holders --
// direct instruction: "use random names but link the panels in logic like the example."
export const HOUSEHOLD = { cook: "Priya", shopper: "Devon" };
export const TONIGHT_DINNER = {
    title: "Chili & skillet cornbread",
    servings: 6,
    minutes: 50,
    chili: {
        have: ["ground beef", "kidney beans", "diced tomatoes", "onion", "garlic", "cumin"],
        missing: ["chili powder"],
    },
    bread: {
        have: ["flour", "cornmeal", "eggs", "sugar"],
        missing: ["buttermilk"],
    },
};
export const ALERTS = [
    { id: "a1", label: "Furnace filter is 8 days overdue", tone: "overdue" },
    { id: "a2", label: "Missing 2 ingredients for tonight's dinner", tone: "due" },
];
export const TODAY_TODOS = [
    { id: "t1", label: `Ask ${HOUSEHOLD.shopper} to pick up chili powder & buttermilk`, done: false },
    { id: "t2", label: "Confirm Saturday haircut", done: true },
    { id: "t3", label: "Take Jake to soccer practice, 5:30p", done: false },
    { id: "t4", label: "Reply to GreenLine about next month's schedule", done: false },
];
// Weekly household spending, by category -- purely illustrative bar-chart data.
export const SPENDING_BY_WEEK = [
    { week: "Wk 1", groceries: 142, home: 40, services: 60 },
    { week: "Wk 2", groceries: 168, home: 0, services: 0 },
    { week: "Wk 3", groceries: 151, home: 220, services: 54 },
    { week: "Wk 4", groceries: 176, home: 0, services: 45 },
];
export const CHORE_REQUESTS = [
    { id: "candy", label: "Buy candy from the store", direction: "asked_of", person: "Sarah", status: "requested" },
    { id: "laundry", label: "Do the laundry", direction: "asked_by", person: "Sarah", status: "requested" },
    { id: "library", label: "Return library books", direction: "asked_of", person: "Sarah", status: "done" },
];
export const KID_CHORES = [
    { id: "trash", label: "Take out the trash", kid: "Jake", pay: null, done: false },
    { id: "lawn", label: "Mow the lawn", kid: "Jake", pay: "$10", done: false },
    { id: "room", label: "Clean room", kid: "Emma", pay: null, done: false },
    { id: "homework", label: "Homework check", kid: "Emma", pay: null, done: true },
];
export const CALENDAR_EVENTS = [
    { day: "MON", week: 0, label: "Furnace filter overdue", tone: "overdue" },
    { day: "WED", week: 0, label: "Chili & bread night", tone: "accent" },
    { day: "FRI", week: 0, label: "Lawn mowing", tone: "track" },
    { day: "SAT", week: 0, label: "Haircut 10:30a", tone: "track" },
    { day: "SAT", week: 0, label: "Jake: mow lawn ($10)", tone: "neutral" },
    { day: "WED", week: 1, label: "Oil change due", tone: "due" },
    { day: "SUN", week: 1, label: "Water heater flush due", tone: "due" },
    { day: "SAT", week: 1, label: "Christmas lights — plan by today", tone: "due" },
];
